import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import LeadCaptureModal from '../components/LeadCaptureModal';

const LeadModalContext = createContext(null);

export function LeadModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('Founding Plan');
  const [prefillEmail, setPrefillEmail] = useState('');

  const openModal = useCallback((planName = 'Founding Plan', emailHint = '') => {
    setSelectedPlan(planName);
    setPrefillEmail(emailHint || '');
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ openModal, closeModal }),
    [openModal, closeModal]
  );

  return (
    <LeadModalContext.Provider value={value}>
      {children}
      <LeadCaptureModal
        isOpen={isOpen}
        onClose={closeModal}
        selectedPlan={selectedPlan}
        prefillEmail={prefillEmail}
      />
    </LeadModalContext.Provider>
  );
}

export function useLeadModal() {
  const ctx = useContext(LeadModalContext);
  if (!ctx) throw new Error('useLeadModal must be used within LeadModalProvider');
  return ctx;
}
